import React, { Fragment } from 'react';

import Dropdown from 'components/cosmos/dropdown';
import { useTranslation } from 'configs/translationContext';
import { inject } from 'mobx-react';
import { BulkDrippingStore } from 'modules/content/dripping/stores';
import { FeatureToggles } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import { PREVIOUS, SCHEDULER_OPTIONS } from './constants';
import SchedulerHeader from './SchedulerHeader';
import SchedulerItem from './schedulerItem';

import './Selector.scss';

const DIVIDED_INDEX = 2;

const mapStateToProps = (stores) => ({
  isDrippingByClassEnabled: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.DrippingByClass
  ),
  isActionInProgress: stores.BulkDrippingStore.isActionInProgress
});

const Selector = ({
  transition,
  setOpenRemoveModal,
  toogle,
  hasPrevious,
  type,
  updateWizardState,
  isDrippingByClassEnabled,
  isActionInProgress
}) => {
  const { t } = useTranslation();

  const handleCloseDropdown = () => {
    toogle?.();
    Dropdown.closeMenu();
  };

  const handleGoToPrevious = (e) => {
    if (hasPrevious) {
      e?.stopPropagation();
      updateWizardState?.(PREVIOUS);
      transition(PREVIOUS, { type });
    }
  };

  const renderDrippingOptions = () => {
    if (isDrippingByClassEnabled) {
      const OPTIONS = [
        {
          label: t('dripping_2.actions.new'),
          onClick: () => BulkDrippingStore.startNewAction()
        },
        {
          label: t('dripping_2.actions.remove'),
          onClick: () => BulkDrippingStore.startDeleteAction()
        }
      ];

      return (
        <>
          {OPTIONS.map(({ label, onClick }) => (
            <Dropdown.MenuItem
              key={label}
              role="button"
              className="ca-scheduler__menu-item _pl-5 _pr-5"
              disabled={isActionInProgress}
              onClick={onClick}
            >
              <span className="ca-scheduler__item">
                <p
                  className="ca-scheduler__label"
                  data-test="ca-selector-label"
                >
                  {label}
                </p>
              </span>
            </Dropdown.MenuItem>
          ))}
        </>
      );
    }

    return Object.values(SCHEDULER_OPTIONS).map((item, index) => (
      <Fragment key={item.title}>
        <SchedulerItem
          data-test={item.title}
          item={{
            ...item,
            label: t(item.title),
            onClick: (e) => {
              e.stopPropagation();
              if (item.modal) {
                setOpenRemoveModal(true);
              } else {
                updateWizardState && updateWizardState(item.selector);
                transition(item.selector, { type: item.type });
              }
            }
          }}
          t={t}
        />
        {index === DIVIDED_INDEX && (
          <Dropdown.MenuDivider className="_ml-5 _mr-5" />
        )}
      </Fragment>
    ));
  };

  return (
    <>
      <SchedulerHeader
        closeDropdown={handleCloseDropdown}
        goToPrevious={handleGoToPrevious}
        title="general.schedule"
      />
      {renderDrippingOptions()}
    </>
  );
};

Selector.propTypes = {
  t: PropTypes.func,
  setOpenRemoveModal: PropTypes.func,
  transition: PropTypes.func,
  toogle: PropTypes.func,
  type: PropTypes.string,
  hasPrevious: PropTypes.bool,
  updateWizardState: PropTypes.func
};

export default inject(mapStateToProps)(Selector);
export { SchedulerItem, Selector };
